import "./MessageHandwriteCard.scoped.scss";

interface Props {
  readonly name: string;
  readonly twitterID: string;
  readonly file: string;
  readonly option: string;
}

// 1枚分のメッセージカードを表現するコンポーネント
export default function MessageHandwriteCard(props: Props) {
  const link = "https://twitter.com/" + props.twitterID;
  const img = `${process.env.PUBLIC_URL}/img/messages/${props.file}`;
  const alt_text =
    "Illustration by " + props.name + "(@" + props.twitterID + ")";
  return (
    <div className="card">
      <img src={img} alt={alt_text} loading="lazy" />
      {(() => {
        // 画像に対してツイッターリンクを貼ります。
        // areaタグを使おうと思ったけどレスポンシブ対応が難しそうだったのでdivタグで代用
        switch (props.option) {
          // 右上に名前が書かれているぞえさん用
          case "name_rightup":
            return (
              <a href={link} target="_blank" rel="noreferrer">
                <div className="author_rightup"></div>
              </a>
            );
          // しっぽ部分に名前がない人用
          // テキスト版と同様のリンク設置を行う
          case "noname":
            return (
              <div className="author_link">
                {props.name}
                <br />
                <a
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  className="App-link"
                >
                  {`@${props.twitterID}`}
                </a>
              </div>
            );
          // しっぽ部分に手書きの名前がある人用
          default:
            return (
              <a href={link} target="_blank" rel="noreferrer">
                <div className="author"></div>
              </a>
            );
        }
      })()}
    </div>
  );
}
